import { z } from 'zod';
import { coerceBoolean } from '../../validation';

export const AppointmentFollowedUpUpdateSchema = z.object({
  followedUp: coerceBoolean(z.boolean()),
});
